import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Limpiar todo el localStorage
    localStorage.clear();
    
    // Redirigir al login
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-blue-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center">
        {/* Icono de éxito */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          ¡Pago Exitoso! 🎉
        </h2>

        <p className="text-gray-600 mb-6">
          Tu suscripción ha sido activada correctamente.
        </p>

        <div className="bg-green-50 border border-green-200 rounded-2xl p-4 mb-6">
          <p className="text-sm text-gray-700">
            ✅ Suscripción activa<br/>
            📅 Válida por 30 días<br/>
            💳 Próximo cobro: {new Date(Date.now() + 30*24*60*60*1000).toLocaleDateString('es-AR')}
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 mb-6">
          <p className="text-sm text-gray-700 font-medium">
            ℹ️ Para aplicar los cambios, por favor cerrá sesión y volvé a iniciarla.
          </p>
        </div>

        <button
          onClick={handleLogout}
          className="w-full bg-gradient-to-r from-blue-500 via-cyan-500 to-green-500 text-white py-4 rounded-2xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
        >
          Cerrar Sesión
        </button>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;